var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"full-height bg-gray"},[_c('el-main',{staticClass:"page-content"},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view',{staticClass:"res"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }